module.exports = __webpack_public_path__ + "static/media/booster.38630340.webp";